module.exports = __webpack_public_path__ + "static/media/user_icon.e5b08271.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/icons/user_icon.svg
// module id = 1933
// module chunks = 1